import React, {useCallback, useEffect, useState} from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  MenuItem,
  ListItem,
  ListItemAvatar, ListItemText, IconButton, Stack, Checkbox
} from '@mui/material';
import api from "../../../services/api";
import List from "@mui/material/List";
import {DownloadRounded, ImageRounded} from "@mui/icons-material";
import Avatar from "@mui/material/Avatar";
import Zoom from "react-medium-image-zoom";
import Tooltip from "@mui/material/Tooltip";
import VisibilityOffOutlinedIcon from "@mui/icons-material/VisibilityOffOutlined";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import {toaster} from "../../../services/toaster";
import {file} from "../../../schema/file";

interface ConfirmDialogProps {
  open: boolean;
  onClose: () => void;
  row: any;
}

const AttachmentDialog: React.FC<ConfirmDialogProps> = ({
                                                          open,
                                                          onClose,
                                                          row,
                                                        }) => {
  const [rows, setRows] = useState<any[]>([]);
  const [loading, setLoading] = useState<boolean>(false);

  const fetchData = useCallback(() => {
    setLoading(true);
    api.get(`/activity-reservations/${row?.id}/service-reservation-files`,).then((result: any) => {
      setRows(result);
      setLoading(false);
    });
  }, []);

  useEffect(() => {
    fetchData();
  }, []);

  const downloadImage = (response: any, fileName: string) => {
    const imageBlob = new Blob([response], {type: response?.type});
    const imageUrl = URL.createObjectURL(imageBlob);
    const link: any = document.createElement('a');
    link.href = imageUrl;
    link.download = fileName ? fileName : 'image.png';
    document.body.appendChild(link);
    link.click();
    link.parentNode.removeChild(link);
  };
  const handleDownload = (attachment: any) => {
    const searchParams = new URLSearchParams({
      fileName: attachment?.name,
      path: 'public',
    });
    api
      .getFile(`/download-file`, searchParams)
      .then((res: any) => {
        downloadImage(res, attachment?.name);
      })
      .catch((error) => {
        console.log(error);
        toaster.show({
          icon: 'error',
          message: `Error while download data`,
          intent: 'danger',
        });
      });

    return true;
  };

  const handleUpdateImage = useCallback(
    async (image: any, data: any) => {
      file.client
        .update(image?.id, data)
        .then((res: any) => {
          const oldProperties = [...rows];
          const newRows = oldProperties.map((row: any) => {
            return row.id === image.id ? res : row;
          });
          setRows(newRows);
        })
        .catch((e: any) => {
          console.error(e);
        });
    },
    [rows]
  );


  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>{row?.name} - Confirmations</DialogTitle>
      <DialogContent>
        <List>

          {rows.map((file, idx) => {
            const filename = file?.name;
            const fileUrl = file.link;
            const isImage = /\.(jpg|jpeg|png|gif)$/i.test(fileUrl);
            const isPdf = /\.pdf$/i.test(fileUrl);

            const handleFileClick = () => {
              if (isImage || isPdf) {
                window.open(fileUrl, '_blank'); // új lapon nyit
              } else {
                const link = document.createElement('a');
                link.href = fileUrl;
                link.download = filename;
                link.click();
              }
            };

            return (
              <ListItem
                sx={{
                  paddingRight: '88px',
                  background: '#f9f9f9',
                  borderRadius: '10px'
                }}
                secondaryAction={
                  <Stack direction={'row'}>
                    <Tooltip title="Visible to Guide">
                      <Checkbox
                        size={'small'}
                        checked={
                          file?.guide_visible
                            ? file.guide_visible
                            : false
                        }
                        inputProps={{'aria-label': 'Checkbox demo'}}
                        icon={<VisibilityOffOutlinedIcon fontSize={'small'}/>}
                        checkedIcon={
                          <VisibilityOutlinedIcon fontSize={'small'} color={'primary'}/>
                        }
                        onChange={(event) => {
                          handleUpdateImage(file, {
                            guide_visible: event.target.checked,
                          });
                        }}
                      />
                    </Tooltip>
                    <Tooltip title="Download file">
                      <IconButton
                        onClick={() => {
                          handleDownload(file);
                        }}
                        size={'small'}
                        edge="end"
                        aria-label="download"
                      >
                        <DownloadRounded fontSize={'small'}/>
                      </IconButton>
                    </Tooltip>
                  </Stack>
                }
              >
                <ListItemAvatar>
                  {isImage ? (
                    <Zoom>
                      <Avatar src={isImage ? fileUrl : ''}/>
                    </Zoom>
                  ) : (
                    <>
                      <Avatar>
                        <ImageRounded/>
                      </Avatar>
                    </>
                  )}
                </ListItemAvatar>
                <ListItemText
                  onClick={()=>{
                    handleFileClick();
                  }}
                  sx={{
                    '&:hover':{
                      cursor: 'pointer'
                    }
                  }}
                  primary={filename}
                  secondary={`Created: ${file?.created_at}`}
                />
              </ListItem>
              /* <MenuItem key={idx} onClick={handleFileClick}>
                 {filename}
               </MenuItem>*/
            );
          })}
        </List>

      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
      </DialogActions>
    </Dialog>
  );
};

export default AttachmentDialog;
